import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { AuthService } from '../../auth/services/auth.service';
import { endpoints } from '../../utils/endpoints';
import { TournamentsResponse } from '../models/api/responses/tournaments.response';
import { Filter } from '../store/actions/allTournaments.action';

@Injectable({
    providedIn: 'root'
})
export class AllTournamentsService {
    private http = inject(HttpClient);
    private authService = inject(AuthService);


    getAllTournaments(page: number, filters: Filter): Observable<TournamentsResponse> {
        return this.http
            .get<TournamentsResponse>(
                this.authService.isAuthorised
                    ? endpoints.tournaments.children.getAllTournamentsAuth({
                          page,
                          filters,
                      })
                    : endpoints.tournaments.children.getAllTournaments({
                          page,
                          filters,
                      })
            )
            .pipe(
                // Configure shareReplay to avoid memory leaks by setting refCount to true
                shareReplay({ bufferSize: 1, refCount: true })
            );
    }
}
